import React from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";

const PanelHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-bottom: 1px solid #dde6f0;
    background: #f6f9fc;
`;

const HeaderInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

const HeaderText = styled.div`
    min-width: 0;
`;

const Title = styled.div`
    font-size: 14px;
    font-weight: 800;
    color: #132238;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Subtitle = styled.div`
    font-size: 12px;
    color: #6d7f96;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const RailBody = styled.div`
    flex: 1;
    min-height: 0;
    padding: 12px;
    overflow: auto;
    background: #fbfcfe;
`;

const Stack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const SearchCard = styled.section`
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 12px;
    gap: 8px;
    border: 1px dashed #c9d6e5;
    border-radius: 14px;
    background: #ffffff;
    overflow: hidden;
`;

const SearchForm = styled.form`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const SearchInput = styled.input`
    flex: 1;
    min-width: 0;
    height: 30px;
    padding: 0 9px;
    border: 1px solid #d2dce8;
    border-radius: 8px;
    background: #ffffff;
    color: #1f3347;
    font-size: 13px;
    outline: none;
`;

const SearchButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    padding: 0 8px;
    border: 1px solid #d5dee8;
    border-radius: 6px;
    background: #ffffff;
    color: #32485e;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: #eef3f7;
    }

    &:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
`;

const SearchSummary = styled.div`
    font-size: 11px;
    color: #5f7489;
`;

const SearchResultList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const SearchResultItem = styled.button`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #dde7f1;
    border-radius: 8px;
    background: #ffffff;
    text-align: left;
    cursor: pointer;
`;

const SearchResultMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 10px;
    color: #5f7489;
`;

const SearchResultPath = styled.div`
    font-size: 11px;
    font-weight: 700;
    color: #1e344a;
`;

const SearchResultSnippet = styled.div`
    font-size: 11px;
    line-height: 1.35;
    color: #344b60;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

function ManuscriptSearchPanel({
    searchQuery,
    setSearchQuery,
    onSearchSubmit,
    searchLoading,
    searchResults,
    onSearchResultSelect,
}) {
    return (
        <>
            <PanelHeader>
                <HeaderInfo>
                    <Icon name={"search"} size={"16px"} color={"#0f8f6f"} />
                    <HeaderText>
                        <Title>검색</Title>
                        <Subtitle>전체 파일 검색</Subtitle>
                    </HeaderText>
                </HeaderInfo>
            </PanelHeader>
            <RailBody>
                <Stack>
                    <SearchCard>
                        <SearchForm
                            onSubmit={(event) => {
                                event.preventDefault();
                                onSearchSubmit?.();
                            }}
                        >
                            <SearchInput
                                value={searchQuery}
                                onChange={(event) => setSearchQuery(event.target.value)}
                                placeholder="파일명 또는 본문 검색"
                            />
                            <SearchButton type="submit" disabled={searchLoading || !searchQuery.trim()}>
                                검색
                            </SearchButton>
                        </SearchForm>
                        <SearchSummary>
                            {searchLoading
                                ? "검색 중..."
                                : searchResults.length
                                  ? `${searchResults.length}개 결과`
                                  : "검색 결과가 없습니다."}
                        </SearchSummary>
                    </SearchCard>
                    <SearchResultList>
                        {searchResults.map((result) => (
                            <SearchResultItem key={result.id} onClick={() => onSearchResultSelect?.(result)}>
                                <SearchResultPath>{result.path}</SearchResultPath>
                                <SearchResultMeta>
                                    <span>{result.kind === "content" ? "본문" : "파일명"}</span>
                                    {result.line ? <span>Ln {result.line}</span> : null}
                                </SearchResultMeta>
                                {result.snippet ? <SearchResultSnippet>{result.snippet}</SearchResultSnippet> : null}
                            </SearchResultItem>
                        ))}
                    </SearchResultList>
                </Stack>
            </RailBody>
        </>
    );
}

export default ManuscriptSearchPanel;
